



























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DataSource from 'devextreme/data/data_source';
import dialog from 'devextreme/ui/dialog';
import { DxButton } from 'devextreme-vue/button';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import { FileParseUploadDto } from '@/models/file-parsing/FileParseUploadDto';

@Component({
  components: {
    DxButton,
    DxLoadPanel,
    DxSelectBox
  }
})
export default class FileParseUploads extends Vue {
  private readonly fileParseUploadsUrl: string = '/FileParseUploads';
  private client: QuestelServicesClient = new QuestelServicesClient(this.$store, '/api');
  private fileParseUploads: FileParseUploadDto[] = [];

  selectedUpload: FileParseUploadDto | null = null;
  loading: boolean = false;

  @Prop()
  readonly complete?: boolean;

  get fileParseUploadsDataSource(): DataSource {
    return new DataSource({
      store: this.fileParseUploads,
      paginate: true,
      pageSize: 100
    });
  }

  async created() {
    await this.loadFileParseUploads();
  }

  private async loadFileParseUploads() {
    let url = this.getFileParseUploadsUrl();
    this.fileParseUploads = await this.client.get<FileParseUploadDto[]>(url);
  }

  private getFileParseUploadsUrl() {
    let query = this.getFileParseUploadsQueryString();
    return `${this.fileParseUploadsUrl}${query}`;
  }

  private getFileParseUploadsQueryString() {
    let parameters: string[] = [];

    if (this.complete != null) {
      parameters.push(`complete=${this.complete}`);
    }

    return parameters.length > 0 ? `?${parameters.join('&')}` : '';
  }

  async onCompleteClicked(e: any) {
    await this.completeSelectedUpload();
  }

  private async completeSelectedUpload() {
    if (this.selectedUpload == null) {
      return;
    }

    let url = `${this.fileParseUploadsUrl}/${this.selectedUpload.FileParseUploadId}`;
    this.loading = true;

    await this.client.sendRequest(HttpMethodEnum.Patch, url)
      .then(async response => {
        let message = 'Upload completed successfully.';
        if (response != null && response.Message != null) {
          message = response.Message;
        }
        await dialog.alert(message, 'Success');
        await this.loadFileParseUploads();
        this.selectedUpload = null;
      })
      .catch(async response => {
        let message = 'An error occurred completing the upload.';
        if (response != null && response.Message != null) {
          message = response.Message;
        }
        await dialog.alert(message, 'Error');
      })
      .finally(() => {
        this.loading = false;
      });
  }

  fileParseUploadDisplayExpression(fileParseUpload?: FileParseUploadDto) {
    if (fileParseUpload == null) {
      return '';
    }

    let client = fileParseUpload.Client == null ? 'Unknown client' : fileParseUpload.Client.ClientName;
    let batch = fileParseUpload.Batch == null ? 'Unknown batch' : fileParseUpload.Batch.BatchName;
    let agent = fileParseUpload.Agent == null ? undefined : fileParseUpload.Agent.AgentName;
    let fileList = fileParseUpload.FileList;
    let result = client;

    if (agent != null) {
      result += ` | ${agent}`;
    }

    result += ` | ${batch}`;

    result += ` | ${fileList}`;

    let createdDate = new Date(fileParseUpload.CreatedDate);
    result += ` | ${createdDate.toLocaleString()}`;

    return result;
  }
}
